import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './root/auth.guard';
import { InternalGuard } from './root/internal.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('src/app/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'pickup',
    loadChildren: () => import('./pickup/pickup.module').then((m) => m.PickupModule),
  },
  {
    path: 'dropoff',
    loadChildren: () => import('./dropoff/dropoff.module').then((m) => m.DropoffModule),
  },
  {
    path: 'work-orders',
    loadChildren: () => import('./work-order/work-order.module').then((m) => m.WorkOrderModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'sites',
    loadChildren: () => import('./sites/sites.module').then((m) => m.SitesModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'assets',
    loadChildren: () => import('./assets/assets.module').then((m) => m.AssetsModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'reservations',
    loadChildren: () => import('src/app/reservations/reservations.module').then((m) => m.ReservationsModule),
  },
  {
    path: 'uploads',
    loadChildren: () => import('src/app/uploads/uploads.module').then((m) => m.UploadsModule),
  },
  {
    loadChildren: () => import('src/app/internal/internal.module').then((m) => m.InternalModule),
    path: 'internal',
    canActivate: [AuthGuard, InternalGuard],
  },
  {
    loadChildren: () => import('src/app/pickup-dropoff/pickup-dropoff.module').then((m) => m.PickupDropoffModule),
    path: 'pickup-dropoff',
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
